import { useEffect, useState } from "react";
import { ListagemTipos } from "../tipos/ListagemTipos";
import { MigracaoSugerida } from "./MigracaoSugerida";
import { ITipo_Indice_Documento } from "../../../services/api/tipo_indice/Tipo_Indice_Service";
import { Tipo_Indice_Service } from "../../../services/api/tipo_indice/Tipo_Indice_Service";
import { IIndice_Documento, IAlterarTipoDocumentoPayload } from "../../../services/api/documento/DocumentoService";
import { ConversorDeValorIndice } from "../../indices/ConversorDeValorIndice";

interface IAlterarTipoProps {
    /**
     * Bolean que indica se o model deve ser aberto ou fechado
     * */
    abrir: boolean;

    AoConfirmar: (dados: IAlterarTipoDocumentoPayload) => void;
    AoCancelar: () => void;
    idSetor: number;
    idDocumento: number;
    idTipoOrigem: number;
    indicesDocumentoOrigem: IIndice_Documento[];
}

export const AlterarTipo: React.FC<IAlterarTipoProps> = 
    ({ abrir, idSetor, idDocumento, idTipoOrigem, indicesDocumentoOrigem, AoCancelar, AoConfirmar }) => {
    const [selectedIdTipo, setSelectedIdTipo] = useState<number>(0);
    const [abrirListagemTipos, setAbrirListagemTipos] = useState<boolean>(abrir);
    const [abrirMigracao, setAbrirMigracao] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [rowsIndiceOrigem, setRowsIndiceOrigem] = useState<ITipo_Indice_Documento[]>([]);
    const [rowsIndiceDestino, setRowsIndiceDestino] = useState<ITipo_Indice_Documento[]>([]);
    const [valoresOrigem, setValoresOrigem] = useState<string[]>([]);
    const [valoresDestino, setValoresDestino] = useState<string[]>([]);

    const resetarEstado = () => {
        setSelectedIdTipo(0);
        setRowsIndiceOrigem([]);
        setRowsIndiceDestino([]);
        setValoresOrigem([]);
        setValoresDestino([]);
        setAbrirMigracao(false);
        setAbrirListagemTipos(false);
        setIsLoading(false);
    };

    const fecharFluxo = () => {
        resetarEstado();
        AoCancelar();
    };

    const carregarDadosMigracao = async () => {
        if (selectedIdTipo === 0 || idDocumento === 0 || idTipoOrigem === 0) {
            return;
        }

        setIsLoading(true);

        try {
            const [indicesOrigemResult, indicesDestinoResult] = await Promise.all([
                Tipo_Indice_Service.getByIdTipo(idTipoOrigem, false),
                Tipo_Indice_Service.getByIdTipo(selectedIdTipo, false),
            ]);

            setIsLoading(false);

            if (indicesOrigemResult instanceof Error || indicesDestinoResult instanceof Error) {
                fecharFluxo();
                return;
            }

            setRowsIndiceOrigem(indicesOrigemResult);
            setRowsIndiceDestino(indicesDestinoResult);

            const valoresOriginaisPorIndice = new Map<number, string>();
            indicesDocumentoOrigem.forEach((indiceDocumento) => {
                valoresOriginaisPorIndice.set(indiceDocumento.idIndice, ConversorDeValorIndice.paraValorUI(indiceDocumento));
            });

            const valoresLadoOrigem = indicesOrigemResult.map((indice) => valoresOriginaisPorIndice.get(indice.idIndice) ?? "");
            const valoresLadoDestino = indicesDestinoResult.map((indice) => valoresOriginaisPorIndice.get(indice.idIndice) ?? "");

            setValoresOrigem(valoresLadoOrigem);
            setValoresDestino(valoresLadoDestino);
            setAbrirMigracao(true);
            setAbrirListagemTipos(false);
        } catch (error) {
            setIsLoading(false);
            fecharFluxo();
        }
    };

    const handleConfirmarMigracao = () => {
        const indice_documentos: IIndice_Documento[] = ConversorDeValorIndice
            .paraPayload(rowsIndiceDestino, valoresDestino)
            .map((payload) => ({ ...payload, idDocumento }));

        AoConfirmar({
            idTipo: selectedIdTipo,
            idDocumento,
            indice_documentos,
        });
    };

    useEffect(() => {
        if (abrir) {
            setAbrirListagemTipos(true);
            setAbrirMigracao(false);
            return;
        }

        resetarEstado();
    }, [abrir]);

    return (
       !abrirMigracao ?
        (
            <ListagemTipos
                txtTooltip="Selecione um tipo"
                abrir={abrirListagemTipos}
                idSetor={idSetor}
                setIdTipo={(idTipo) => setSelectedIdTipo(idTipo)}
                AoConfirmar={carregarDadosMigracao}
                AoCancelar={fecharFluxo}
            />
        ) :
        (
            <MigracaoSugerida
                AoConfirmar={handleConfirmarMigracao}
                AoCancelar={fecharFluxo}
                abrir={abrirMigracao}
                isLoading={isLoading}
                rowsIndiceOrigem={rowsIndiceOrigem}
                rowsIndiceDestino={rowsIndiceDestino}
                valoresOrigem={valoresOrigem}
                valoresDestino={valoresDestino}
                onValoresDestinoChange={setValoresDestino}
            />
        )
    );
}